import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models for M207 (庫位板號修改單)
// ============================================================

export interface FM210 {
  fm210_01: string;          // 修改單號 (PK)
  fm210_11: string | null;   // 日期 (ISO string)
  fm210_12: string;          // 建立人員
  fm210_13: string;          // 部門代號
  fm210_14: string;          // 庫位代號
  fm210_15: number;          // 總項數
  fm210_80: string;          // 核准狀態 N/P
  fm210_91: string;          // modifier
  fm210_92: string | null;   // modify date
  fm210_93: string;          // modify note

  // Associations
  details?: FM211[];
}

export interface FM211 {
  fm211_01: string;          // 修改單號 FK
  fm211_02: number;          // 項次
  fm211_11: string;          // 批號
  fm211_121: string;         // 產品大類碼
  fm211_122: string;         // 產品細類碼
  fm211_13: number;          // 板號數量小計
  fm211_14: string;          // 色卡代號

  // Associations
  board_numbers?: FM212[];
}

export interface FM212 {
  fm212_01: string;          // 修改單號 FK
  fm212_02: number;          // 項次 FK
  fm212_03: number;          // 板號流水號
  fm212_11: string;          // 舊板號
  fm212_12: string;          // 新板號
}

// ============================================================
// Request / Response types
// ============================================================

export interface M207ListResponse {
  data: FM210[];
  total: number;
  page: number;
  size: number;
}

export interface M207CreateRequest {
  master: Partial<FM210>;
  details: Partial<FM211>[];
}

export interface ValidationError {
  field: string;
  rule: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const m207Api = {
  async list(page = 1, size = 20): Promise<M207ListResponse> {
    const res = await apiClient.get('/api/m207', { params: { page, size } });
    return res.data;
  },

  async get(id: string): Promise<FM210> {
    const res = await apiClient.get(`/api/m207/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: M207CreateRequest): Promise<FM210> {
    const res = await apiClient.post('/api/m207', data);
    return res.data;
  },

  async update(id: string, data: M207CreateRequest): Promise<FM210> {
    const res = await apiClient.put(`/api/m207/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/api/m207/${encodeURIComponent(id)}`);
  },
};
